import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { SubscriptionLike } from 'rxjs';
import { itemUnsubscribe } from '../../../utils';
import { AuthService } from '../../services';
import { LoginData } from '../../../api';
import { RoutePath } from '../../../models';

@Component({
  selector: 'app-auth-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.sass'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class LoginPageComponent implements OnDestroy {
  registration = `${RoutePath.registration}`;
  private subs: SubscriptionLike[] = [];

  login(data: LoginData): void {
    this.subs.push(this.auth.login(data).subscribe());
  }

  ngOnDestroy(): void {
    itemUnsubscribe(this.subs);
  }

  constructor(public auth: AuthService) {
  }
}
